export default {
    "welcome": "欢迎使用旺诊云～",
    "header": {
        "headerMenu": {
            "switchClinics": "切换诊所",
            "changePwd": "修改密码",
            "frequentlyUsed": "常用功能",
            "logout": "退出",
            "multiLang": "多语言",
            "switchLang": "Switch Language"
        },
        "changePwdModal": {
            "title": "修改密码",
            "tabs": [
                "验证码修改",
                "密码修改"
            ],
            "formPhr": {
                "mobile": "输入手机号码",
                "code": "输入短信验证码",
                "sendBtn": "获取验证码",
                "sendBtnWait": "{sec}秒后重新获取",
                "password": "设置密码",
                "confirmPwd": "确认新密码",
                "oldPassword": "输入旧密码",
                "newPassword": "设置新密码",
                "confirmBtn": "确认修改"
            }
        },
        "changeTenantModal": {
            "title": "切换诊所",
            "okBtn": "关闭",
            "lastLogin": "上次登录：",
            "msgLoading": "正在切换中，请稍后",
            "msgSuccess": "切换成功！"
        },
        "logoutModal": {
            "title": "确认退出",
            "content": "是否确认退出当前账号？"
        },
        "msgCode": {
            "registerFail": "该手机号未注册",
            "success": "验证码发送成功"
        },
        "msgUpdatePwd": {
            "success": "密码修改成功",
            "mobileFail": "请输入正确的手机号",
            "codeFail": "验证码不正确",
            "pwdFail": "密码格式不正确",
            "pwdSameFail": "两次密码输入不一致"
        },
        "switchLang": {
            "title": "Switch Language",
            "warning": "请勿修改符号{}里面的内容，以免程序异常运行"
        }
    },
    "exception": {
        "desc": "抱歉，你访问的页面不存在或仍在开发中",
        "back": "返回首页"
    },
    "loginPage": {
        "loginForm": {
            "tabs": [
                "账号密码登录",
                "验证码登录"
            ],
            "account": "输入手机号码",
            "password": "输入密码",
            "forgetPwd": "忘记密码",
            "code": "输入短信验证码",
            "sendBtn": "获取验证码",
            "sendBtnWait": "{sec}秒后重新获取",
            "autoLogin": "下次自动登录",
            "login": "登 录",
            "loginLoading": "正在登录中，请稍后",
            "forgetTitle": "找回密码",
            "setPassword": "设置密码",
            "confirmPwd": "确认密码",
            "confirmChange": "确认修改",
            "hasAccount": "已有账号？",
            "highLight": " 登录 "
        },
        "selectTent": {
            "logout": "更换账号",
            "search": "诊所名称搜索",
            "lastLogin": "上次登录：",
            "lastLoginNone": "无",
            "listNone": "暂无可登录的诊所"
        },
        "leftTopLOGO": {
            "tententName": "旺诊云诊所管理平台",
            "tententNameSmall": "WANG ZHEN CLOUD CLINIC MANAGEMENT PLATFORM"
        },
        "rightTopBtns": {
            "vedio": "演示视频",
            "freeUse": "免费试用"
        }
    },
    "account": {
        "roleSearchPlaceHolder": "角色名称搜索",
        "roleTitle": "角色",
        "roleInfo": "角色信息",
        "addRole": "新增角色",
        "rolePermission": "角色权限",
        "name": "角色名称",
        "isStop": "启/停用",
        "menuName": "模块名称",
        "userSearchPlaceHolder": "手机号/用户姓名搜索",
        "addUser": "新增用户",
        "authority": "权限",
        "userInfo": "用户信息",
        "doctorProfile": "医生简介",
        "visiblePatient": "可见所有看诊患者：",
        "roleList": "角色清单",
        "setPermission": "设置权限",
        "permissionSet": "权限设置",
        "mobile": "手机号码",
        "job": "职务",
        "positionalTitles": "职称",
        "ybgjCode": "国家医保编码"
    },
    "doctorWorking": {
        "filter": {
            "patiname": "患者姓名搜索",
            "fastRegis": "接诊",
            "tab_1": "待诊",
            "tab_2": "已诊"
        },
        "viewWork": "查看工作量",
        "telPrefix": "手机号：",
        "memo": "备注：",
        "reportBtn": "查看报告",
        "historyBtn": "历史病历",
        "tabExtra": {
            "setDrop_1": "模块设置",
            "setDrop_2": "病历设置",
            "menuBtn": "套餐",
            "menuDrop_1": "药品套餐",
            "menuDrop_2": "治疗套餐",
            "saveTemBtn": "保存为模板",
            "saveForm": {
                "packageName": "模板名称",
                "memo": "备注"
            },
            "templateBtn": "处方模板",
            "submitBtn": "看诊完成"
        },
        "negotiateAmt": "待收金额：",
        "bargain": "议价",
        "bargainTip": "点击看诊完成，该议价方可生效",
        "recoverBtn": "恢复",
        "bargainMemo": "备注",
        "recoverDefault": "恢复默认",
        "setTitle_1": "选择需要展示的模块",
        "setTitle_2": "选择需要的病历字段",
        "statisticAll": "合计",
        "submitSuccess": "接诊完成",
        "chargedTip": "收费员已对该处方做了收费操作。如有必要，可退费后重新开具新处方。",
        "checkLength": "至少选择一条数据！",
        "judge": "库存不足！",
        "tipName": "【{name}】",
        "modal": {
            "report": "查看报告",
            "history": "历史病历",
            "stack": "处方模板",
            "print": ""
        },
        "verifyLimit": {
            "noneName": "普通",
            "nameJoin": "，",
            "joinName": "【{names}】为{typeName}类药品；",
            "unTypeSame": "不同类别药品不可同一处方！",
            "unLimitSame": "不可与{name}类药品同一处方！"
        }
    },
    "examine": {
        "executionReport": {
            "queryText": "患者姓名/检查编号/检查项目搜索",
            "inspectionType": "检查类型",
            "saveReport": "保存报告",
            "cancelAudit": "取消审核",
            "auditReport": "审核报告",
            "printReport": "打印报告",
            "risReport": "检验项目：",
            "lisRegisterTitle": "检查编号：",
            "uploadImg": "上传图像",
            "pleaseUplad": "请上传{name}",
            "noData": "暂无数据",
            "formLabelSetting": "{name}设置",
            "configDefault": "设为默认",
            "default": "默认",
            "addFormLabel": "新增{name}",
            "lisName": "检验",
            "risName": "检查"
        }
    },
    "execution": {
        "filter": {
            "patiName": "姓名",
            "date_1": "就诊日期",
            "date_2": "结束日期"
        },
        "tab_1": "待执行",
        "tab_2": "已执行",
        "tag": "诊断",
        "history": "历史病历",
        "historyPrint": "处方重印",
        "record": "执行记录",
        "recordMemo": "执行备注",
        "cancelUser": "取消人",
        "registerUser": "登记人",
        "deleted": "已取消",
        "cancelBtn": "取消执行",
        "execModal": {
            "title": "执行",
            "execTime": "执行时间",
            "checkAll": "全选",
            "execCount": "已执行",
            "execTimes": "本次执行",
            "timesUnit": "次",
            "execMemo": "执行备注",
            "execLabel": "执行信息",
            "execUser": "执行人",
            "execChoose": "请选择执行项目！",
            "execUserChoose": "请选择执行人！"
        },
        "setModal": {
            "title": "备注设置",
            "name": "备注"
        },
        "loading": "正在加载中，请稍后再试！",
        "mustChoose": "请先选择一个病历！",
        "cancelModal": {
            "title": "确认取消执行",
            "content": "是否确认取消执行？"
        },
        "disposal": {
            "title": "执行信息",
            "execCount": "执行({count}/{amount})"
        },
        "injection": {
            "print_1": "打印输注单",
            "print_2": "打印瓶贴",
            "title": "执行信息",
            "groupTitle": "输注群组{no}",
            "execCount": "执行({count}/{allCount})",
            "skinTitle": "皮试信息",
            "skinText": "皮试",
            "skinResult": "结果",
            "skinEdit": "编辑",
            "skin_1": "阴性(-)",
            "skin_2": "阳性(+)",
            "execName": "执行人",
            "execTime": "执行时间",
            "execMemo": "备注",
            "column": {
                "chargeUnitnum": "单次数量",
                "skin": "皮试"
            }
        },
        "execSuccess": "执行成功！"
    },
    "inspect": {
        "components": {
            "simplingInfo": "采样组信息",
            "gender": "性别",
            "age": "年龄",
            "minValue": "最小值",
            "maxValue": "最大值",
            "addItem": "加一组",
            "patientName": "患者姓名",
            "unKnowSex": "未知",
            "machineConfirm": "上机确认",
            "machine": "仪器",
            "codeOrNameSearch": "样本条码/患者姓名搜索",
            "confirmSaveForm": "确认匹配检验结果？",
            "observationLabel": "样本条码：",
            "patientNameLabel": "患者：",
            "lisNameLabel": "检验项目：",
            "machineCode": "上机编号",
            "reportPrint": "报告重印",
            "projectNameLabel": "{name}项目：",
            "condition": "Condition"
        },
        "checkDetails": {
            "searchPlaceholder": "细项代码/细项名称搜索",
            "addBtnTxt": "新增检验细项",
            "editBtnTxt": "编辑检验细项",
            "integer": "整数",
            "float": "{name}位小数",
            "resultType1": "数值型",
            "resultType2": "文字型",
            "resultType3": "阴阳型",
            "moreGroup": "多组",
            "oneFroup": "单组",
            "resultType4": "Computational",
            "Uncomputation": "Uncomputation"
        },
        "detailsRelevance": {
            "lisWorkgroupPlaceholder": "采样组",
            "queryTextPlaceholder": "名称/拼音码搜索",
            "addLisTitle": "新增检验项目",
            "editLisTitle": "编辑检验项目",
            "rightTab": "检验细项关联",
            "rightAddBtnTxt": "新增检验细项",
            "projectName": "项目名称：",
            "addChildrenPlaceholder": "请输入细项代码或细项名称",
            "childrenIsExist": "检验细项已存在！",
            "pleaseChooseItem": "请选择检验细项！",
            "delTip": "【{name}】删除后无法恢复（删除范围包含连带档、表单明细、处方模板明细），确定删除？",
            "isSaveFormTip": "是否保存{name}检验细项？"
        },
        "sampling": {
            "addBtnTxt": "新增采样组",
            "warning": "所有检验项目按照采样组分组，相同采样组的项目开立后只需采1份样本，生成1个样本条码，检验结果合并在1张报告中"
        },
        "inspectReport": {
            "queryText": "患者姓名/样本条码/检验项目搜索",
            "printCode": "打印条码",
            "saveReport": "保存报告",
            "cancelAudit": "取消审核",
            "auditReport": "审核报告",
            "printReport": "打印报告",
            "lisReport": "检验项目：",
            "fastCopy": "Simple Copy"
        },
        "signIn": {
            "startTime": "看诊日期",
            "endTime": "结束日期",
            "queryText": "患者姓名/患者档案号搜索",
            "recordCode": "档案号：",
            "signAndPrint": "签收并打印条码",
            "unSign": "退签",
            "printCode": "打印条码",
            "receive": "已签收",
            "unReceive": "未签收",
            "unSignTip": "请勾选未签收的检验项目！",
            "signTip": "请勾选已签收的检验项目！",
            "signSuccess": "签收成功！",
            "returedSuccess": "退签成功！"
        },
        "common": {
            "samplingName": "采样组名称",
            "workgroupColorId": "采样管",
            "subLisCode": "细项代码",
            "subLisName": "细项名称",
            "resultTypeName": "结果类型",
            "decimalPlace": "数值小数位",
            "unitName": "单位",
            "fanWei": "参考范围",
            "referenceValue": "参考值",
            "projectName": "项目名称",
            "hospitalName": "检验项目名称",
            "specimenTypeName": "检体",
            "lisWorkgroupName": "采样组",
            "subLisCodeSimple": "代码",
            "isStop": "启/停用",
            "edit": "编辑",
            "observationId": "样本条码",
            "orderName": "检验项目",
            "chargeStatus": "收费状态",
            "creationTime": "开单时间",
            "chargeTime": "收费时间",
            "checkInTime": "签收时间",
            "analysisTime": "检验时间",
            "patientName": "患者",
            "openContentService": "{name}，确定启用？",
            "openContent": "【{name}】确定启用？",
            "stopContentService": "{name}，确定停用？",
            "stopContent": "【{name}】确定停用？",
            "delContentService": "{name}，确定删除？",
            "delContent": "【{name}】确定删除？",
            "openTip": "是否确认启用【{name}】？",
            "stopTip": "是否确认停用【{name}】？",
            "diseaseName": "诊断：",
            "beCharge": "已收费",
            "unBeCharge": "未收费",
            "machine": "仪器",
            "status": "状态",
            "auditStatus_1": "待检",
            "auditStatus_2": "待审核",
            "auditStatus_3": "已审核",
            "visitTypeTitle": "来源：",
            "observationTitle": "样本条码：",
            "specimenNameTitle": "检体：",
            "applyTimeTitle": "申请时间：",
            "reportPeopleNameTitle": "报告人：",
            "reportTimeTitle": "报告时间：",
            "auditReeopleNameTitle": "审核人：",
            "auditTimeTitle": "审核时间：",
            "projectCode": "项目代码",
            "resultValue": "提示",
            "result": "结果",
            "remarkTitle": "备注：",
            "auditReportSuccessTip": "审核报告成功！",
            "saveReportSuccessTip": "保存报告成功！",
            "confirmCancelAudit": "确认取消审核？",
            "cancelAuditSuccessTip": "取消审核成功！",
            "compareSuccessed": "匹配成功!",
            "machineName": "Machine Name",
            "channelNumber": "Channel No.",
            "orderMemoForCustomer": "Significance",
            "options": "Options",
            "computationalFormula": "Computational Formula"
        },
        "machineList": {
            "addBtnTxt": "Add Equipment",
            "warning": "Manually added instruments do not support automatic connection.",
            "machineForm": "Equipment Information",
            "machineName": "Equipment Name"
        }
    },
    "maintenance": {
        "tabsList": {
            "deptInfo": "科室信息维护",
            "collectFee": "收费项目维护",
            "formMaintain": "表单维护",
            "storeroom": "扣库设置",
            "kzLevel": "看诊级别维护",
            "diagnosis": "诊断维护",
            "setting": "系统设置"
        },
        "deptPlaceHolder": "科室/诊室名称搜索",
        "addDept": "新增科室",
        "deptInfo": "科室信息",
        "deptName": "科室名称",
        "ybDeptOne": "医保科室",
        "ybDeptTwo": "子科室",
        "stopReason": "停用原因",
        "room": "诊室",
        "roomInfo": "诊室信息",
        "addRoom": "新增诊室",
        "roomName": "诊室名称",
        "roomLocation": "诊室位置",
        "stopTips": "请输入【{name}】停用原因",
        "stopTips3": "停用此科室会把相应的排班同时停用，请确认是否操作？",
        "startTips1": "确认启用",
        "startTips2": "是否确认启用 【{name}】 ？",
        "delTips1": "确认删除",
        "delTips2": "是否确认删除 【{name}】 ？",
        "tipsReason": "请输入停用原因！",
        "deptFrom": "所属科室",
        "deptFromName": "所属科室名称",
        "openLis": "启用检验管理",
        "runLis": "执行检验",
        "creatCanLis": "开单后可执行检验",
        "payCanLis": "收费后可执行检验",
        "lisSign": "检验签收",
        "signCanReport": "需检验签收，才可填写报告",
        "unSignCanReport": "无需报告审核，亦可打印报告",
        "openRis": "启用检查管理",
        "runRis": "执行检查",
        "creatCanRis": "开单后可执行检查",
        "payCanRis": "收费后可执行检查",
        "risAudit": "检查报告审核",
        "auditCanPrint": "需报告审核，才可打印报告",
        "unAuditCanPrint": "无需报告审核，亦可打印报告",
        "lisConfig": "检验设置",
        "risConfig": "检查设置",
        "collectFee": {
            "tabAll": "全部",
            "filter": {
                "drugType": "药品分类",
                "drugMainform": "剂型大分类",
                "queryText": "名称/拼音码/条形码搜索"
            },
            "actBtns": {
                "addProject": "新增项目",
                "addPrefix": "新增"
            },
            "tableTitle": {
                "name": "查询项目",
                "total": "项目总计"
            },
            "tableAct": {
                "edit": "编辑",
                "del": "删除"
            },
            "tableColumn": {
                "orderTypeName": "项目类型",
                "price": "销售单价(元)",
                "chargeUnitName": "销售单位",
                "medListCodg": "医保编码",
                "creationTime": "创建日期",
                "status": "启/停用",
                "orderCode": "Internal Code"
            },
            "removeModal": {
                "title": "确认删除",
                "content": "【{name}】删除后无法恢复（删除范围包含连带档、表单明细、处方模板明细），确定删除？"
            },
            "statusModal": {
                "status_1": "停用",
                "status_2": "启用",
                "title": "确认{status}",
                "content_1": "【{chScientificName}】当前库存量{chargeUnitText}{minUnitText}，确认停用？",
                "content_2": "是否确认{title}【{chScientificName}】？"
            },
            "exportName": "项目维护-{d}"
        },
        "collectEdit": {
            "breadcrumb": {
                "label_1": "收费项目维护",
                "label_edit": "编辑",
                "label_add": "新增"
            },
            "clearBtn": "清屏",
            "platLabel": "从平台添加",
            "plat_p1": "名称/条形码/国药准字号搜索",
            "plat_p2": "名称/条形码搜索",
            "search": "搜索",
            "drugType": "药品分类",
            "drugMainformType": "剂型大分类",
            "chargeUnit": "包装单位",
            "chargeUnit_2": "销售单位",
            "unitSplit": "含",
            "minUnit": "最小单位",
            "dosageUnit": "剂量单位",
            "hisPriceBtn": "调价历史",
            "hisTop": "历史最高",
            "hisEnd": "历史最低",
            "pruchasingBtn": "进价",
            "sciNamePyCode": "学名拼音码",
            "pyCode": "商品名拼音码",
            "unitPlace": "单位",
            "relatedTitle": "连带项目维护",
            "relatedLabel": "连带收费项目",
            "relatedSearch": "连带收费项目搜索",
            "tipConversion": {
                "title": "换算关系示例",
                "p_1": "最小单位，指最小规格的单位，如片、粒、支，当单次剂量不足最小单位时，按最小单位算发药数量。",
                "p_2": "以阿奇霉素片举例，规格为0.2g*10片每盒，则换算关系维护：",
                "p_3": "每包装单位",
                "p_4": "盒",
                "p_5": "片",
                "p_6": "，每"
            },
            "modalMsg": {
                "bigHasKucun": "当前收费项目有库存，请出库后再修改{text}！",
                "bigStorage": "由于存在出入库记录，修改{text}时，需将原收费项目状态改为停用，新增一条修改后的数据，确认修改？",
                "minHasKucun": "当前收费项目最小单位有库存，请出库后再修改最小单位！",
                "minStorage": "由于存在出入库记录，修改最小单位时，需将原收费项目状态改为停用，新增一条修改后的数据，确认修改？"
            },
            "platColumn": {
                "guoyaozhunzi": "批准文号",
                "barCode": "条形码"
            },
            "renderForm": {
                "chScientificName": "中文学名",
                "chScientificNameSuffix_1": "名称",
                "chScientificNameSuffix_2": "项目",
                "chTradeName": "中文商品名",
                "drugType": "药品分类",
                "drugSpec": "规格",
                "opdTransrate": "每包装单位",
                "dosageTransrate": "每最小单位",
                "price": "销售单价",
                "dismantlePrice": "允许拆零",
                "substituteOrderCode": "条形码",
                "permitCode": "批准文号",
                "manufacture": "生产厂商",
                "pinyinCode": "拼音码",
                "drugFormType": "剂型子分类",
                "drugLimitType": "限制类别",
                "pharmacologyType": "药理分类",
                "antibioticLevelType": "抗菌药物级别",
                "dosage": "预设剂量",
                "freq": "预设频率",
                "usages": "预设用法",
                "costPrice": "成本单价",
                "feesProcessed": "代加工费",
                "specimenType": "检体",
                "lisWorkgroup": "采样组",
                "lisWorkgroupTip": "所有检验项目按照采样组分组，相同采样组的项目开立后只需采1份样本，生成1个样本条码，检验结果合并在1张报告中。",
                "instrument": "仪器",
                "inspectionType": "检查类型",
                "inventoryUpper": "库存上限",
                "inventoryFloor": "库存下限",
                "orderCode": "Internal Code",
                "orderMemo": "Order Entry Information",
                "medicationDetais": "Notes Or Medication Detais",
                "filelist": "Promotional Image",
                "orderMemoForCustomer": "Significance"
            },
            "relatedTableColumn": {
                "chScientificName": "名称",
                "drugSpec": "规格",
                "tqty": "总量"
            },
            "relatedColumn": {
                "orderTypeName": "项目类型",
                "chScientificName": "中文学名",
                "drugSpec": "规格",
                "chargeUnitName": "门诊单位"
            }
        },
        "diseaseType": "诊断分类",
        "diseasePlaceholder": "诊断名称搜索",
        "d_addInfo": "诊断维护信息",
        "diseaseCode": "诊断编码",
        "diseaseName": "诊断名称",
        "sortOrder": "排序",
        "sheetMainType": "表单类型",
        "addSheet": "新增表单",
        "editSheet": "表单维护",
        "formColumn": {
            "chScientificName": "中文名",
            "specimen": "检体"
        },
        "sheetInfo": "表单信息",
        "sheetDrug": "表单医令",
        "isStop": "启/停用",
        "chSheetName": "表单名称",
        "separateSheetName": "拆单方式",
        "sheetRemarks": "注意事项",
        "chooseSpecimenTips": "请选择检体！",
        "kzLevel": "看诊级别",
        "addKzLevel": "新增看诊级别",
        "kzLevelInfo": "看诊级别信息",
        "ghTitle": "挂号费",
        "ghTitleInfo": "(编辑挂号费请前往「收费项目维护」模块)",
        "chKzLevelName": "看诊级别名称",
        "pyCode": "助记码",
        "amount": "金额(元)",
        "name": "名称",
        "expenseCategoryName": "收费项目",
        "storeroom": "药房管理",
        "storeroomName": "药房名称",
        "storeroomInfo": "药房信息",
        "addStoreroom": "新增药房",
        "toChoose": "请选择",
        "westernMedicineDeductSetup": "西药扣库药房",
        "chinesePatentMedicineDeductRoom": "中成药扣库药房",
        "chineseHerbalMedicineRoom": "中药扣库药房",
        "medicalComponentDeductRoom": "卫材扣库药房",
        "setting_tab_1": "收费设置",
        "setting_tab_2": "数据权限",
        "setting_tab_3": "门诊设置",
        "setting_tab_4": "打印设置",
        "setting_tab_5": "库房设置",
        "setting_tab_10": "汇率设置",
        "designeeAllowToSee": "指定人员可查看",
        "designeeAllowToSee_1": "已选{num}人，修改",
        "choose": "选择",
        "tab1_fy": "同时发药",
        "tab1_fy_1004": "门诊收费时默认同时发药",
        "tab1_fy_1005": "零售收费时默认同时发药",
        "tab1_xp": "打印小票",
        "tab1_xp_1016": "会员充值时默认打印小票",
        "tab1_yj": "议价",
        "tab1_yj_1009": "门诊挂号时允许整单议价",
        "tab1_yj_1010": "门诊收费时允许整单议价",
        "tab1_yj_1011": "零售收费时允许整单议价",
        "tab2_jj": "【收费项目维护】药品、卫材进价",
        "tab2_1012_1013": "有【收费项目维护】权限的允许查看",
        "tab2_cbj": "【收费项目维护】除药品、卫材外的项目成本价",
        "tab2_ypjg": "【门诊作业】医生查看药品价格",
        "tab2_ypjg_1014_1": "允许看到药品单价、总价",
        "tab2_ypjg_1014_2": "只允许看到药品总价",
        "tab2_ypjg_1014_3": "不允许看到药品单价、总价",
        "tab2_mzzy": "【门诊作业】",
        "tab2_mzzy_1001": "药品、卫材库存不足可开立",
        "tab2_lssf": "【零售收费】",
        "tab2_lssf_1002": "药品、卫材库存不足可收费",
        "tab3_kzyl": "【门诊作业】看诊完成后需预览确认完整的病历、处方",
        "tab3_kzyl_1015": "有【门诊作业】权限的都需预览确认",
        "tab3_designeeAllowToSee": "指定人员预览确认",
        "tab3_kzyj": "【门诊作业】看诊时允许医生议价",
        "tab3_kzyj_1017_1": "有【门诊作业】权限的都允许议价",
        "tab3_kzyj_1017_2": "不允许医生议价",
        "tab3_kzyj_1017_3": "指定人员允许议价",
        "tab3_kzsf": "【门诊作业】医生看诊完成后可直接收费",
        "tab3_kzsf_1037_1": "不允许直接收费",
        "tab3_kzsf_1037_2": "有【门诊作业】权限的看诊完成都可直接收费",
        "tab3_kzsf_1037_3": "指定人员看诊完成后可收费",
        "tab3_szyl": "【门诊作业】【处方模板】输注药品用量计算规则",
        "tab3_szyl_1026_1": "单次药品用量用不完丢弃",
        "tab3_szyl_1026_2": "单次药品用量用不完保留",
        "tab3_szyl_1026_1_expend": "例如：规格250ml/瓶，单次剂量150ml，一天3次，系统自动总量为",
        "tab3_szyl_1026_1_expend_unit": "瓶",
        "tab3_rkxgdj": "【入库管理】填写入库单时修改销售单价",
        "tab3_rkxgdj_1027": "有【入库管理】权限的都可修改",
        "tab3_rkxgdj_1027_1": "不可修改",
        "tab3_rkxgdj_1027_2": "指定人员可修改",
        "tab3_rkhxg": "【入库管理】确定入库后，仍可修改入库记录",
        "choosePerson": "选择人员",
        "choosedPerson": "已选人员",
        "choosingPerson": "可选人员",
        "settingDataErrorTips": "获取设置数据失败！",
        "tab3_zybz": "【门诊作业】【处方模板】中药处方备注默认内容",
        "invoiceConfig": {
            "showType_1": "显示项目名称、数量和金额",
            "showType_2": "显示项目名称和数量，不显示金额",
            "showType_3": "显示“{name}费”和总金额",
            "freeType1018": "西成药：",
            "freeType1019": "中药：",
            "freeType1020": "卫材：",
            "freeType1021": "检验：",
            "freeType1022": "检查：",
            "freeType1023": "治疗：",
            "freeType1024": "手术：",
            "freeType1025": "输注附加项：",
            "freeType1038": "收费员",
            "freeType1039": "收费时间",
            "freeType1040": "联系电话",
            "freeType1041": "地址",
            "feeReceipt": "收费小票",
            "invoice": "医疗票据",
            "ticket": "票据",
            "clinicName": "旺诊云诊所",
            "payNote": "收费单",
            "actionType": "{name}费",
            "invoiceItem_1": "姓名： 王先生",
            "invoiceItem_2": "性别： 男",
            "invoiceItem_3": "年龄： 66岁",
            "invoiceItem_4": "费别： 自费",
            "invoiceItem_5": "医生： 旺医生",
            "invoiceItem_6": "科室： 内科",
            "invoiceItem_7": "收 费 员： 雷霆医生",
            "receivable": "应收",
            "receiptAmt": "实收",
            "cash": "现金",
            "weChat": "微信",
            "payTime": "收费时间",
            "moneyUnit": "元",
            "freeTypeName1018": "阿莫西灵胶囊",
            "freeTypeName1019": "葫芦巴",
            "freeTypeName1020": "绷带",
            "freeTypeName1021": "促甲状腺素",
            "freeTypeName1022": "肝胆胰脾肾彩超（已缴费体检）",
            "freeTypeName1023": "艾灸",
            "freeTypeName1024": "微创手术",
            "freeTypeName1025": "静脉输液",
            "unit_dai": "袋",
            "unit_pian": "片",
            "unit_ci": "次",
            "unit_dance": "单侧",
            "unit_tie": "贴"
        },
        "saveInspectModal": {
            "modalTitle": "启用检查管理",
            "alertTip": "启用检查管理，需补全以下检查项目的检查类型",
            "inspectionTypeId": "检查类型",
            "hospitalName": "检查项目名称",
            "formConfirmTips": "{name}请选择检查类型！"
        },
        "saveMaterialModal": {
            "modalTitle": "启用检验管理",
            "alertTip": "启用检验管理，需补全以下检验项目的检体，采样组信息",
            "formConfirmTips": "{name}请选择检体或采样组！"
        },
        "institution": {
            "institutionSetting": "机构设置",
            "institutionName": "机构名称",
            "contactNumber": "联系电话",
            "address": "地址",
            "detailedAddress": "详细地址"
        },
        "exchangeRate": {
            "title": "汇率",
            "historyBtn": "历史汇率",
            "delMsg": "删除该汇率换算公式后，收费时不支持使用{type}支付？"
        },
        "outpatient": "Outpatient",
        "inpatient": "Inpatient",
        "InstitutionConfig": "InstitutionInfor"
    },
    "outpatientCollectfee": {
        "collectfee": {
            "filter": {
                "patiName": "姓名搜索",
                "dateBtn_d1": "当天",
                "dateBtn_d3": "三天",
                "dateBtn_d5": "五天",
                "dateBtn_d": "自定义"
            },
            "tab_1": "待收",
            "tab_2": "已收",
            "isNoCharge": "暂不收费",
            "showNoCharge": "显示暂不收费",
            "mainIdentity": "结算类别",
            "medType": "医疗类别",
            "confirmBtn": "确认收费",
            "negotiatePriceAmt": "医生议价",
            "totalAmount": "费用总额",
            "diagnosis": "诊断",
            "payModalTitle": "确定收费",
            "columnPrice": "单价(元)",
            "columnTqty": "数量",
            "columnAmount": "费用(元)",
            "tip_1": "该患者已收费！",
            "tip_2": "原账单已发生变化！",
            "tip_3": "该患者已收费，请勿重复收费！",
            "tip_4": "原账单已发生变化，请重新确认支付！",
            "mustChoose": "请选择医疗类别！",
            "paySuccess": "收费成功！",
            "noChargeContent": "确认当前账单暂不收费？"
        },
        "dividePrice": {
            "pageName": "收费",
            "form": {
                "patiname": "患者姓名",
                "birthdatetime": "出生日期",
                "sex": "性别",
                "mainIdentity": "看诊身份",
                "section": "科别",
                "employee": "医师",
                "diagnoses": "诊断"
            },
            "btnSuffix": "处方",
            "confirmBtn": "确认收费",
            "payModalTitle": "确定收费",
            "mustOne": "至少保留一个处方",
            "minOne": "请先添加处方药品",
            "tqtyUnZero": "{name}总量不能为空"
        },
        "search": {
            "employeePlaceholder": "医生",
            "creatorUserPlaceholder": "收/退费员",
            "patiNamePlaceholder": "患者姓名搜索",
            "tollCollector": "收费员：",
            "chargebackClerk": "退费员：",
            "returnPremium": "退费",
            "returnPremiumSuccess": "退费成功！",
            "xp": "小票",
            "invoice": {
                "invoiceType_1": "医疗收费发票",
                "invoiceType_2": "收费小票",
                "invoiceNumber": "发票号码：",
                "invoiceSetting": "打印设置"
            },
            "unitPrice": "单价(元)",
            "zcyTqty": "*{num}付",
            "cancelReasonName": "退费原因：",
            "charged": "已收费",
            "refund": "已退费",
            "refundTips": "已发药不能退费！",
            "refundInvoice": "退费成功，对应的发票号码{num}直接作废！",
            "refundInvoice_1": "退费成功，对应的发票号码",
            "refundConfirm": "确认退费",
            "refundConfirm_1": "是否确认进行退费操作？",
            "totalAmount": "Price"
        },
        "report": {
            "startDate": "结账日期",
            "detailModalTitle": "门诊收款日结详情",
            "yjMemo": "议价备注：",
            "exportName": "收费日结报表",
            "tableSet": {
                "chargeUserName": "收费员",
                "totalMedicalAmt": "应收合计(元)",
                "totalDiscountAmt": "优惠金额(元)",
                "totalBargainAmt": "议价(元)",
                "totalShortAmt": "短溢款(元)",
                "totalRefundAmt": "退款金额(元)",
                "totalRealAmt": "实收合计(元)",
                "payType": "支付方式(元)",
                "weChat": "微信",
                "alipay": "支付宝",
                "merge": "聚合支付",
                "cash": "现金",
                "member": "会员",
                "ybCard": "医保卡",
                "numerRMB": "数字人民币",
                "total": "小计",
                "yb": "医保",
                "ybMedicarePay": "统筹基金(元)",
                "ybPersonalPay": "个人账户(元)",
                "projectType": "项目类型(元)",
                "western": "西药",
                "tranditionalMedicine": "中成药",
                "chinese": "中药",
                "medical": "卫材",
                "inspectFee": "检验",
                "check": "检查",
                "treat": "治疗",
                "operation": "手术",
                "register": "挂号费",
                "infusionFee": "输注附加项"
            }
        },
        "amtInfo": {
            "all": "总费用：",
            "fmoney": "{money}元",
            "tcjj": "统筹基金",
            "grzh": "个人账户",
            "yhje": "优惠金额",
            "yj": "议价",
            "dyk": "短溢款",
            "ssjj": "实收金额"
        }
    },
    "outpatientRegistration": {
        "patientStatusList": {
            "placeHolder": "患者姓名/手机号搜索",
            "signIn": "签到",
            "registration": "挂号",
            "prediagnosis": "预诊",
            "paddingDiagnosis": "待诊",
            "finishDiagnosis": "已诊",
            "all": "全部",
            "makeAnAppointment": "预约",
            "yzTitName": "【{name}】预诊"
        },
        "booking": {
            "placeHolder": "医生姓名搜索",
            "today": "今天",
            "tomorrow": "明天",
            "dayAfterTomorrow": "后天",
            "appointmentRegister": "预约挂号",
            "appointmentRegisterTitle": "预约挂号",
            "appointmentSignIn": "预约签到",
            "cancelAnAppointment": "取消预约",
            "returnTheNumber": "退号",
            "caseHistory": "病历",
            "suspendMedicalService": "停诊",
            "beginToTreatPatients": "开诊",
            "wayOfRegistration": "挂号途径",
            "notTelTips": "患者不愿留手机号",
            "isCancelAnAppointment": "是否取消预约？",
            "historicalMedicalRecord": "历史病历",
            "prescriptionReprinting": "处方重印",
            "pleaseSelectData": "请先选择一个病历！",
            "doctorName": "医生",
            "patientSearch": "患者姓名搜索",
            "registerList": {
                "doctorUserName": "医生姓名",
                "timeInterval": "时间段",
                "roomName": "诊间",
                "patiName": "患者姓名",
                "age": "年龄",
                "mainIdentityName": "就诊身份",
                "registerChannelName": "预约途径",
                "visitStatusName": "状态"
            },
            "remainNumber": "余号({num})",
            "ghScheduleTips": "请选择预约挂号时段！",
            "stopScheduleInfo": "停诊信息"
        },
        "scene": {
            "card_title": "所有医生",
            "filter": {
                "section": "科室",
                "doctorName": "医生姓名搜索"
            },
            "actBtn": "挂号",
            "btmLine": "已挂号",
            "person": "人"
        },
        "inquire": {
            "filter": {
                "date": [
                    "看诊日期",
                    "结束日期"
                ],
                "mainIdentity": "看诊身份",
                "employee": "看诊医生",
                "section": "科室",
                "patientName": "患者姓名搜索"
            },
            "actBtn_2": "医疗收费发票",
            "actBtn_3": "挂号小票",
            "actBtn_4": "打印设置",
            "actBtn_5": "退号",
            "tableAct": "预诊",
            "tableColumn": {
                "processTime": "看诊日期",
                "patiName": "患者姓名",
                "sex": "性别",
                "birthdatetime": "出生日期",
                "mainIdentityName": "看诊身份",
                "worktimeName": "时段",
                "sectionName": "科室",
                "doctorUserName": "医师",
                "doctorLevelName": "看诊级别",
                "receiptsAmt": "挂号金额(元)",
                "invoiceNumber": "发票号码",
                "registerChannelName": "挂号途径",
                "visitStatusName": "就诊状态",
                "cancelReasonName": "退号原因"
            },
            "success": "{t}成功，对应的发票号码{n}直接作废！",
            "exportName": "挂号查询(退号)-{d}"
        }
    },
    "patient": {
        "recordFile": {
            "filter": {
                "birthday": [
                    "出生日期",
                    "结束日期"
                ],
                "creationTime": [
                    "建档日期",
                    "结束日期"
                ],
                "patiType": "患者类型",
                "memberId": "会员等级",
                "queryText": "患者姓名/手机号/证件号码搜索"
            },
            "patiType_1": "所有患者",
            "patiType_2": "普通患者",
            "patiType_3": "会员患者",
            "addBtn": "新增患者档案",
            "count": "患者总计",
            "switch_1": "列表",
            "switch_2": "看板",
            "rowEdit": "编辑",
            "rowMember": "会员/卡项",
            "rowHistory": "历史病历",
            "rowHistoryCard": "历史病历",
            "createTime": "建档日期",
            "rePrint": "处方重印",
            "rePrintMustChoose": "请先选择一个病历！",
            "column_1": "患者姓名",
            "column_2": "性别",
            "column_3": "出生日期",
            "column_4": "年龄",
            "column_5": "手机号码",
            "column_6": "证件类型",
            "column_7": "证件号码",
            "column_8": "建档日期",
            "column_9": "最近看诊日期",
            "column_10": "会员等级",
            "exportName": "患者档案-{date}"
        },
        "member": {
            "openTitle": "开通会员",
            "openVerifyTel": "该患者基本信息未填写手机号码，无法开通会员！",
            "level": "会员等级",
            "function": "会员权益",
            "edit": "编辑",
            "integralGrant": "积分发放",
            "integralGrantBtn": "发放",
            "integralGrantNum": "发放积分",
            "integralGrantMemo": "备注",
            "intefralExchangeTitle": "积分兑换",
            "intefralExchangeBtn": "兑换",
            "intefralExchangeNumber": "兑换积分",
            "intefralExchangeItem": "兑换项目",
            "intefralExchangeMemo": "备注",
            "writeOff": "注销",
            "charge": "充值",
            "unpay": "退款",
            "defaultLevel": "普通患者",
            "chargeModal": {
                "title": "会员充值",
                "principalAmt": "充值金额",
                "sendAmt": "赠送金额",
                "moneyUnit": "元",
                "presend": "送{n}元",
                "seller": "销售员",
                "mark": "备注"
            },
            "sellerModal": {
                "title": "销售员设置",
                "name": "销售员"
            },
            "bread_1": "患者档案",
            "bread_2": "会员/卡项",
            "renderTitle": {
                "integral": "积分",
                "member": "会员"
            },
            "listLabel": {
                "availableIntegral": "积分",
                "memberName": "会员等级",
                "memberMoney": "余额",
                "memberRight": "权益"
            },
            "writeOffModal": {
                "title": "确认注销",
                "content": "是否确认注销{name}?",
                "tip_1_title": "会员内剩有余额不可注销",
                "tip_1_content": "会员内仍有余额，请退款后再注销。",
                "tip_2_title": "当前会员已注销",
                "tip_2_content": "当前会员已被注销，点击确定后刷新。"
            },
            "payVerify": "充值金额不能小于等于0！",
            "payTitle": "确定收费",
            "payTip_1": "退费{type}",
            "payTip_2": "充值{type}",
            "balanceColumn": {
                "title": "余额流水",
                "creationTime": "交易时间",
                "tradeTypeName": "交易类型",
                "payTypeName": "支付方式",
                "payTotalAmt": "交易金额(元)",
                "principalAmt": "交易本金(元)",
                "sendAmt": "交易赠金(元)",
                "principalbalance": "本金余额(元)",
                "sendbalance": "赠金余额(元)",
                "patiName": "患者姓名",
                "doctorName": "医生",
                "sellerName": "销售员",
                "chargeUserName": "收费员"
            },
            "deductionColumn": {
                "title": "抵扣权益流水",
                "memberItemName": "抵扣项目",
                "creationTime": "抵扣时间",
                "patiName": "交易客户",
                "deductionTimes": "抵扣次数",
                "remainTimes": "剩余次数",
                "doctorName": "医生",
                "chargeUserName": "收费员"
            },
            "integralColumn": {
                "title": "积分流水",
                "creationTime": "变更时间",
                "changeTypeName": "变更类型",
                "exchangeName": "兑换项目",
                "changeIntegral": "变更积分",
                "remainIntegral": "剩余积分",
                "mark": "备注",
                "creatorUserName": "操作人"
            }
        }
    },
    "dispense": {
        "startDate": "收费日期",
        "placeholder": "患者姓名搜索",
        "chargeDate": "收费时间：",
        "sendMedicineDate": "发药时间：",
        "sendMedicine": "发药",
        "returnMedicine": "退药",
        "toPrint": "处方打印",
        "diagnosisNameJoin": "诊断：",
        "nameAnd": "{name}，",
        "herbalMedicineTcmQuantity": "{num}付",
        "prescriptionOrderDrug": "{num}味药，",
        "feesProcessedName": "代加工：",
        "feesProcessedMomo": ",{memo}",
        "waitSendMedicine": "待发药",
        "alreadySendMedicine": "已发药",
        "days": "{days}天",
        "daysNum": "天数",
        "returnedMedicine": "已退",
        "sendMedicineTips": "该患者已发药，请勿重复发药！",
        "returnNum": "可退数量",
        "returnMedicineNull": "暂无可退药品！",
        "outpatient": "Outpatient",
        "dischargedWithDrugs": "Discharged with Drugs"
    },
    "membership": {
        "member": {
            "memberType": "会员类型",
            "memberPoints": "积分",
            "createdStartDate": "创建日期",
            "placeholder": "会员权益搜索",
            "addMember": "新增会员等级",
            "memberLevelInfo": "会员等级信息",
            "memberLevelName": "会员等级名称：",
            "memberLevelNameNot": "会员等级名称",
            "memberName": "会员等级",
            "memberRights": "会员权益",
            "memberNumber": "会员人数",
            "delTips": "已有患者开通该会员，不可删除!",
            "price": "售价(元)",
            "hdlx": "活动类型",
            "orderTypeName": "项目类型",
            "memo": "备注：",
            "lwChoose": "例外：已选{num}",
            "zhe": "折",
            "discount": "折扣",
            "bargainPrice": "特价",
            "choose": "选择",
            "hdfw": "活动范围：",
            "chooseHdfwProject": "参与活动的项目",
            "membershipMarketing": "会员维护",
            "czmj": "充值满减：",
            "czmj_1": "充值满",
            "czmj_2": "，送",
            "czmj_3": ""
        },
        "chooseModel": {
            "unitCot": "数量",
            "choosed": "已选",
            "placeHolder": "名称搜索",
            "example": "例外选择",
            "project": "项目",
            "projectChoose": "项目选择",
            "type": "类型"
        },
        "jfForm": {
            "title": "积分活动：",
            "syfw": "适用范围：",
            "allPatient": "所有患者",
            "ordinaryPatient": "普通患者",
            "memberPatient": "指定会员",
            "getRule": "获取规则：",
            "getRuleSuccess": "成功消费得积分",
            "consume": "每消费",
            "givePoints": "，积1分",
            "chooseMember": "选择适用会员",
            "chooseAll": "全选",
            "suitableRangeTips": "请选择适用范围！",
            "getMemberTips": "请选择具体指定会员！"
        },
        "marketing": {
            "balance": "会员统计",
            "integral": "积分统计"
        },
        "balance": {
            "statistics": "余额统计",
            "membershipLevel": "会员等级",
            "beginDate": "期初日期",
            "endDate": "期末日期",
            "patiname": "患者姓名搜索",
            "detail": "查看明细",
            "startTotalAmt": "期初合计",
            "rechargeTotalAmt": "充值合计",
            "resumeTotalAmt": "消费合计",
            "remaindTotalAmt": "期末合计",
            "memberName": "会员等级",
            "creationTime": "开通日期",
            "beginAmt": "期初(元)",
            "chargeAmt": "本金",
            "giveAmt": "赠金",
            "totalAmount": "合计",
            "rechargeAmt": "充值(元)",
            "resumeAmt": "消费(元)",
            "endAmt": "期末(元)",
            "balanceStatic": "会员余额统计"
        },
        "integral": {
            "patiNameSearch": "患者姓名搜索",
            "isShowZero": "积分为0不显示",
            "resumeTotalIntegralTotal": "消费累计积分合计",
            "issueTotalIntegralTotal": "累计发放积分合计",
            "exchangeTotalIntegralTotal": "累计兑换积分合计",
            "availableTotalIntegralTotal": "当前积分合计",
            "resumeTotalIntegral": "消费累计积分",
            "issueTotalIntegral": "累计发放积分",
            "exchangeTotalIntegral": "累计兑换积分",
            "availableIntegral": "当前积分"
        },
        "balanceDetail": {
            "detail": "余额明细",
            "creationTime": "交易时间",
            "tradeTypeName": "交易类型",
            "payTypeName": "支付方式",
            "payTotalAmt": "交易金额(元)",
            "principalAmt": "交易本金(元)",
            "sendAmt": "交易赠金(元)",
            "principalbalance": "本金余额(元)",
            "sendbalance": "赠金余额(元)",
            "patiName": "患者姓名",
            "doctorName": "医生",
            "sellerName": "销售员",
            "chargeUserName": "收费员",
            "staticDetail": "会员余额统计明细"
        },
        "integralDetail": {
            "detail": "积分明细",
            "creationTime": "变更时间",
            "changeTypeName": "变更类型",
            "exchangeName": "兑换项目",
            "changeIntegral": "变更积分",
            "creatorUserName": "操作人",
            "staticDetail": "积分统计明细"
        }
    },
    "inventory": {
        "common": {
            "drugRoom": "药房",
            "label": "{name}：",
            "orderType": "项目类型",
            "buyPrice": "进价金额(元)",
            "substituteOrderCode": "条形码",
            "vendorName": "供应商",
            "productNum": "批号",
            "expiredDate": "有效期至",
            "buyPriceTotal": "进价金额合计：",
            "sellPriceTotal": "售价金额合计：",
            "pleaseChoose": "请选择",
            "voucherAbstract": "凭证摘要",
            "operator": "操作人",
            "status": "状态",
            "chargeUnitSellTotalPrice": "销售金额(元)",
            "saveDraftSuccess": "保存草稿成功！",
            "stockAmount": "库存数量",
            "projectName": "{name}项目",
            "varietyNum": "品种数量：",
            "orderPlaceHolder": "输入名称/拼音码/条形码",
            "inStorageTime": "入库时间",
            "product": {
                "choosed": "已选批号({num})",
                "noChoose": "不指定批号"
            },
            "oneMoreTips": "请填写至少一条项目！"
        },
        "outStock": {
            "placeHolder": "名称/拼音码/条形码搜索",
            "isNull": "不显示库存为0",
            "isFlag": "只显示数量达下限",
            "tableTitle": "查询项目",
            "buyTotalPrice": "进价金额合计：",
            "sellTotalPrice": "预计销售金额合计：",
            "inventoryUpper": "库存上限",
            "inventoryUpperTip": "{num}种项目当前库存量高于库存上限",
            "inventoryFloor": "库存下限",
            "inventoryFloorTip": "{num}种项目当前库存量低于库存下限",
            "stop": "停用",
            "costom": "库存量",
            "recentlyCostPrice": "最近进价(元)",
            "sellPrice": "预计销售金额(元)",
            "exportName": "导出数据-实时库存-{date}",
            "outStockName": "实时库存",
            "stockDetail": "库存详情",
            "storageDate": "出/入库日期",
            "typeName": "出/入库",
            "storageTypeName": "类型",
            "storageNum": "单号",
            "unitCot": "数量"
        },
        "checkWarehouse": {
            "checkWarehouseName": "盘点作业",
            "stockCheck": "库存盘点",
            "tempCheck": "临时盘点",
            "createdStartDate": "创建日期",
            "drugRoomCheck": "药房盘点",
            "checkRange": "盘点范围",
            "dosageFormMainType": "剂型大分类",
            "batchCheck": "按批次盘点",
            "checkNum": "盘点单号",
            "projectType": "项目类别",
            "placeHolder": "项目名称/条形码/拼音码搜索",
            "isHideZero": "不显示库存为0",
            "checkFinish": "完成盘点",
            "checkFinish_1": "完成盘点！",
            "import": "导入",
            "checkProject": "盘点项目",
            "stockAmount": "系统库存量",
            "checkAmount": "盘点库存量",
            "checkId": "盘点ID",
            "projectCode": "项目编码",
            "isSplit": "是否拆零",
            "checkOutpatient": "盘点门诊库存量",
            "checkOutpatientUnit": "盘点门诊库存量单位",
            "checkSplit": "盘点拆零库存量",
            "checkSplitUnit": "盘点拆零库存量单位",
            "importFail": "导入失败！",
            "orderType": "Item Category"
        },
        "wareHouse": {
            "in": {
                "inStorage": "入库",
                "inStorageName": "入库管理",
                "inStorageType": "入库方式",
                "inStorageDate": "入库日期",
                "placeHolder": "入库单号/同行单号/项目名称搜索",
                "inStorageRange": "入库范围",
                "inStorageNum": "入库单号",
                "inStorageNumTong": "同行单号",
                "inStorageHouse": "入库药房",
                "inStorageVariety": "品种数量",
                "inStorageNumNow": "本次入库数量",
                "unit": "单位",
                "buyPrice": "进价(元)",
                "sellPrice": "销售单价(元)",
                "profitRate": "利润率",
                "productDate": "生产日期",
                "inStorageSuccess": "确认入库成功！",
                "manualEntry": "手动录入",
                "importExcel": "导入随货同行单Excel",
                "chooseExcel": "选择随货同行单Excel",
                "importExcelTips": "请确认随货同行单Excel列标题与系统标题对应准确",
                "excelTableSet": {
                    "name": "旺诊云系统标题",
                    "excelName": "随货同行单Excel列标题",
                    "example": "第一行数据示例"
                },
                "importErrorTips": "导入失败,请重新选择文件！"
            },
            "out": {
                "outStorage": "出库",
                "outStorageName": "出库管理",
                "outStorageType": "出库类型",
                "outStorageDate": "出库日期",
                "placeHolder": "出库单号/项目名称搜索",
                "outStorageRange": "出库范围",
                "stockAmount": "剩余数量",
                "outStorageNum": "出库单号",
                "outStorageHouse": "出库药房",
                "outStorageNumNow": "出库数量",
                "moreStockAmountTip": "部分医令出库数量超出现有库存数量，请调整！",
                "outStorageSuccess": "确认出库成功！"
            },
            "edit": {
                "saveDraft": "保存草稿",
                "confirm": "确定{name}",
                "changeSellPrice": "修改销售单价",
                "nullTips": "请填写必填项！",
                "zeroTips": "部分项目的出库数量为0！",
                "noMatchTips": "存在未匹配项目，无法保存！",
                "noEditTips": "已有相关的出库记录，无法编辑！"
            }
        },
        "supplier": {
            "searchPlaceholder": "名称搜索",
            "tableTop": "供应商",
            "totalCount": "总计",
            "editTitle": "供应商维护",
            "vendorName": "供应商名称",
            "pyCode": "拼音码",
            "sort": "排序号",
            "contactUserName": "联系人",
            "contactPhoneNumber": "联系电话",
            "status": "状态",
            "column": {
                "vendorName": "名称",
                "sort": "排序",
                "startStop": "启/停用"
            },
            "modalTitle": "确认{t}",
            "modalContent": "是否确认{t}【{name}】"
        }
    },
    "statistical": {
        "operationstatistical": {
            "overView": "概览",
            "operatingIndex": "运营指标",
            "ordersell": "收费项目统计",
            "opdFeeSummaryReportByUser": "收费员统计",
            "opdFeeSummaryReport": "收费明细",
            "opdFeeSummaryReportByMonth": "月汇总",
            "opdFeeSummaryReportByDay": "日汇总",
            "opdFeeSummaryReportByDoctor": "医生统计",
            "opdFeeSummaryReportByPharmacist": "药师统计",
            "opdRegisterInfoDetail": "门诊日志",
            "treatmentExecution": "治疗执行统计",
            "age": "岁"
        },
        "storagestatistical": {
            "inStorage": "入库统计",
            "outStorage": "出库统计",
            "storageWarning": "效期预警",
            "storageUnsalablWarning": "滞销预警",
            "vendorStorage": "供货统计",
            "inOutStorage": "出入库明细",
            "purchaseSaleStock": "进销存报表"
        },
        "overView": {
            "alertTip": "实收合计 = 挂号收入 + 门诊收入 + 零售收入",
            "chargeSellPriceAmt": "实收合计(元)",
            "chargeBuyPriceAmt": "成本金额(元)",
            "profitAmount": "毛利金额(元)",
            "profitRate": "毛利率",
            "returnAmt": "退款金额(元)",
            "registerSellPriceAmt": "挂号收入(元)",
            "opdSellPriceAmt": "门诊收入(元)",
            "pricechargeSellPriceAmt": "零售收入(元)",
            "memberRechargeAmount": "会员充值(元)",
            "cardRecharge": "卡项充值(元)",
            "payTypeTip": "总金额 = 实收合计 + 会员充值",
            "payTotalAmt": "支付总金额(元)",
            "filterTypeDay": "按天",
            "filterTypeMonth": "按月",
            "filterTypeYear": "按年",
            "revenueStatistics": "营业额统计",
            "revenueAmt": "营业额(元)",
            "visitsNum": "看诊人次",
            "payType": "支付方式",
            "payType_1": "现金",
            "payType_2": "聚合",
            "payType_3": "医保卡",
            "payType_4": "支付宝",
            "payType_5": "微信",
            "payType_6": "会员",
            "payType_7": "数字人民币",
            "diagnTop10": "疾病诊断Top10",
            "ageStatistics": "年龄段看诊人次统计",
            "timeGroupStatistics": "不同时段看诊人次统计",
            "statisticsLoadingTip": "统计数据正在加载中"
        },
        "ordersell": {
            "orderType": "项目类型",
            "chTradeName": "项目名称搜索",
            "alertTip": "当前存在待发药处方，可能影响成本计算，请及时发药！",
            "chargeProject": "收费项目",
            "exportFileName": "导出数据-收费项目统计"
        },
        "orderselldetail": {
            "pageTitle": "处方明细",
            "mainIdentity": "看诊身份",
            "nameSearch": "医生姓名/患者姓名搜索",
            "alertTip": "当前存在待发药处方，可能影响成本计算，请及时发药！",
            "exportTitle": "导出数据-收费项目统计-处方明细"
        },
        "opdfeesummaryreportbyuser": {
            "chargeDetailByDay": "门诊收款日结详情",
            "exportTitle": "导出数据-收费员统计"
        },
        "opdfeesummaryreport": {
            "mainIdentity": "看诊身份",
            "nameSearch": "医生姓名/患者姓名/项目名称搜索",
            "alertTip": "实收金额采用加权平均算法，保留小数点后两位",
            "exportTitle": "导出数据-处方明细"
        },
        "opdfeesummaryreportbydoctor": {
            "doctorUser": "看诊医生",
            "section": "科室",
            "isHideZero": "成本合计和应收合计都为0不显示",
            "alertTip": "当前存在待发药处方，可能影响成本计算，请及时发药！",
            "exportTitle": "导出数据-医生统计"
        },
        "inStorage": {
            "exportTitle": "导出数据-入库统计"
        },
        "outStorage": {
            "exportTitle": "导出数据-出库统计"
        },
        "storageWarning": {
            "pharmacy": "药房",
            "expireDate": "即将失效天数",
            "expired": "已过期"
        },
        "storageUnsalablWarning": {
            "unSoleDays": "滞销天数",
            "days": "天数"
        },
        "purchaseSaleStock": {
            "drugType": "项目类型",
            "chScientificName": "项目名称搜索",
            "stopUse": "停用",
            "exportTitle": "导出数据-进销存报表"
        },
        "commonTableSet": {
            "totalMedicalAmt": "应收合计(元)",
            "discountAmt": "优惠金额(元)",
            "artificialDiscountAmt": "议价(元)",
            "totalPayableMinusAmt": "短溢款(元)",
            "returnAmt": "退款金额(元)",
            "totalReceiveAmt": "实收合计(元)",
            "payType": "支付方式",
            "weChatFee": "微信",
            "aliPayFee": "支付宝",
            "mergeFee": "聚合支付",
            "cashFee": "现金",
            "cardFee": "会员",
            "ybCardFee": "医保卡",
            "numerRMBFee": "数字人民币",
            "totalFee": "小计",
            "yb": "医保",
            "ybMedicarePayAmt": "统筹基金(元)",
            "ybAccountPayAmt": "个人账户(元)",
            "projectType": "项目类型(元)",
            "prescriptionDetails": "处方明细",
            "receiptsAmt": "实收金额",
            "chargeUnitBuyTotalPriceAmount": "成本金额",
            "profitAmount": "毛利金额",
            "profitRate": "毛利率",
            "creationTime": "收费时间",
            "creatorUserName": "收/退费员",
            "chargeStatusName": "收费状态",
            "storageTypeName": "发药状态",
            "mainIdentityName": "看诊身份",
            "applyDoctorName": "接诊医生",
            "patientName": "患者名称",
            "patientName_1": "患者姓名",
            "orderTypeName": "项目类型",
            "storageType": "入库类型",
            "roomName": "药房名称",
            "orderTypeCount": "收费项目品种",
            "chargeUnitAmt": "收费项目数量",
            "chargeUnitBuyTotalPrice": "进价金额(元)",
            "chargeUnitSellTotalPrice": "销售金额(元)",
            "storageTypeExport": "出库类型",
            "pharmacy": "药房",
            "productNum": "批号",
            "expiryDate": "有效期至",
            "unitCot": "库存量",
            "unSoleDays": "滞销天数",
            "beginDate": "期初",
            "endDate": "期末",
            "importStore": "入库",
            "exportStore": "出库",
            "departmentName": "科室",
            "cot": "接诊人次",
            "projectTotalAmt": "项目合计(元)",
            "totalAmount": "应收",
            "totalReceiveAmount": "实收",
            "costTotalAmount": "成本",
            "profitAmt": "毛利",
            "registerFeeAmount": "挂号费(元)",
            "westernFeeAmount": "西药费(元)",
            "tranditionalMedicineFeeAmount": "中成药费(元)",
            "chineseFerbFeeAmount": "中药费(元)",
            "sanitationFeeAmount": "卫材费(元)",
            "treatFeeAmount": "治疗费(元)",
            "checkFeeAmount": "检查费(元)",
            "inspectFeeAmount": "检验费(元)",
            "surgeryFeeAmount": "手术费(元)",
            "infusionFeeAmount": "输注附加费(元)"
        }
    },
    "templateManager": {
        "tab_section": "科室处方模板",
        "tab_personal": "个人处方模板",
        "filter": {
            "section": "科室",
            "packageName": "模板名称搜索"
        },
        "addBtn_1": "新增科室模板",
        "addBtn_2": "新增医师模板",
        "edit": "编辑",
        "column": {
            "sectionName": "科室",
            "packageName": "模板名称"
        },
        "delModal": {
            "title": "确认删除",
            "content": "是否确认删除？"
        },
        "editModal": {
            "title_add": "新增模板",
            "title_edit": "编辑模板",
            "packageName": "模板名称"
        }
    },
    "workforce": {
        "template": {
            "workTimeBtn": "班别管理",
            "allSection": "全部科室",
            "viewBtn": "查看",
            "pauseBtn": "粘贴",
            "writeBtn": "排班",
            "popupModal": {
                "title": "排班信息",
                "copyBtn": "复制",
                "timeInterval": "预约间隔{t}分钟，可预约{n}人"
            },
            "addForm": {
                "doctorLevel": "看诊级别",
                "section": "看诊科室",
                "room": "诊间",
                "interval": "预约间隔",
                "time": "分钟，可预约",
                "person": "人"
            },
            "workTimeModal": {
                "addBtn": "新增班别",
                "title": "班别信息",
                "name": "班别名称",
                "beginTime": "开始时间",
                "endTime": "结束时间"
            },
            "msg": {
                "copyFail": "当前排班信息为空，无法复制",
                "copySuccess": "复制成功！",
                "pauseSuccess": "粘贴成功！",
                "timeRange": "排班时间重合，请重新选择",
                "timeEquality": "开始时间不能等于结束时间"
            },
            "delModal": {
                "title": "确认删除",
                "content": "是否确认删除？"
            }
        },
        "mananger": {
            "filter": {
                "date": [
                    "看诊日期",
                    "结束日期"
                ],
                "name": "医生姓名搜索"
            },
            "addBtn": "新增排班",
            "workModal": {
                "title": "排班信息",
                "visitDate": "看诊日期",
                "doctorUser": "看诊医生",
                "section": "看诊科室",
                "room": "诊间",
                "doctorLevel": "看诊级别",
                "interval": "预约间隔",
                "time": "分钟，可预约",
                "person": "人"
            },
            "copyBtn": "复制排班",
            "copyModal": {
                "tip": "按照排班模板复制排班",
                "checked": "全选",
                "date": "排班日期",
                "allSection": "全部"
            },
            "exportName": "排班管理-{date}",
            "stopReason": {
                "title": "请输入【{name}】停用原因",
                "reason": "停用原因"
            },
            "column": {
                "visitDate": "看诊日期",
                "workName": "班别",
                "sectionName": "看诊科室",
                "roomName": "诊间",
                "doctorUserName": "看诊医师",
                "doctorLevelName": "看诊级别",
                "timeinterval": "预约间隔(分钟)",
                "stayReason": "停用原因"
            },
            "delModal": {
                "title": "确认删除",
                "content": "是否确认删除？"
            },
            "startModal": {
                "title": "确认启用",
                "content": "是否确认启用【{name}】"
            },
            "msg": {
                "actSuccess": "操作成功！",
                "timeRange": "排班时间重合，请重新选择",
                "lengthZero": "请添加排班时间",
                "copyLengthZero": "请选择排班医生！",
                "copySuccess": "复制成功！"
            }
        }
    },
    "formCreation": {
        "formCreation": "表单开立",
        "placeHolder": "名称搜索",
        "checkAll": "全选"
    },
    "modelTable": {
        "refunded": "已退费",
        "partRefund": "部分退",
        "returnRatio": "已退{n}付",
        "rebateText": "{name} 已退 {unit}",
        "charged": "已收费",
        "exist": "已存在！",
        "signDel": "已签收，请单个删除！",
        "signDelSingle": "【{name}】已签收，不可删除！",
        "signChangeSingle": "【{name}】已签收，不可切换！",
        "remarkSet": "备注设置",
        "placeHolder": "输入名称或拼音码",
        "stock": "库存",
        "drugs": "药品",
        "consumables": "卫材",
        "unmatched": "未匹配",
        "addDrug": "新增药品",
        "addConsumables": "新增卫材"
    },
    "pianYuCom": {
        "common": "常用"
    },
    "payModel": {
        "printConfig": {
            "receiptTypeName": "票据类型",
            "isPreview": "是否预览",
            "printNumers": "打印份数",
            "registeredReceipt": "挂号小票",
            "feeReceipt": "收费小票",
            "invoice": "医疗收费发票",
            "longDispenseList": "Long-term Medical Order Prescription",
            "shortDispenseList": "Temporary Medical Order Prescription",
            "giveDrugList": "Print of Drug Administration List"
        }
    },
    "tableCom": {
        "serialNumber": "序号",
        "dateChoose": "选择日期"
    },
    "tipsCom": {
        "confirm": "确认"
    },
    "prescriptionTable": {
        "medicalRecords": {
            "soapChiefComplaint": "主诉",
            "soapIllnessHistory": "现病史",
            "soapPreviousHistory": "既往史",
            "soapFamilyHistory": "家族史",
            "soapPhysicalExamination": "体格检查",
            "soapLookSmellFeel": "望闻切诊",
            "soapAuxiliaryExamination": "辅助检查",
            "opdDiagnosis": "诊断",
            "opdDiscriminate": "辨证",
            "opdTreatment": "治法",
            "soapTreatmentAdvice": "治疗意见",
            "attachments": "附件",
            "attachmentsPlaceholder": "上传{label}",
            "examination": {
                "tem": "体温",
                "pulse": "度，脉搏",
                "breathe": "次/分钟，呼吸",
                "heartRate": "次/分钟，心率",
                "heartRateUnit": "次/分钟，",
                "bloodPressure": "血压",
                "diastolicPressure": "舒张压",
                "systolicPressure": "mmHg，收缩压",
                "end": "mmHg；"
            },
            "requiredMsg": "请至少选择一条诊断",
            "bloodMsg": "请参照格式输入血压！",
            "bloodTip": {
                "title": "血压值示例",
                "p_1": "血压由舒张压/收缩压组成，例如：血压",
                "p_2": "mmHg，解释为舒张压80mmHg/收缩压120mmHg。"
            }
        },
        "westernMedicine": {
            "title": "西/成药处方{index}",
            "addPlaceholder": "输入名称、拼音码或条形码",
            "addBtn": "新增西成药处方",
            "requiredMsg": "西/成药的剂量、频率、途径、天数、单位不能为空"
        },
        "chineseHerbal": {
            "title": "中药处方{i}",
            "readTitleRight": {
                "name": "{name}，",
                "ratio": "{n}付，",
                "length": "{n}味药，"
            },
            "drugForm": "剂型",
            "usage": "水煎服",
            "decoctionMethod": "煎法",
            "decoctionMethodSetBtn": "煎法设置",
            "addBtn": "新增中药处方",
            "requiredMsg": "中药剂量不能为空",
            "requiredMsg_2": "中药代加工不能为空",
            "requiredMsg_3": "中药代加工费用不能为空"
        },
        "injectionView": {
            "eisaiTitle": "附加项目",
            "title": "输注群组{i}",
            "extra": "{freq}，{usage}，{days}天",
            "freq": "频率",
            "usage": "用法",
            "days": "天数",
            "daysUnit": "天",
            "skin": "皮试",
            "addBtn": "新增输注群组",
            "requiredMsg": "输注药品的剂量、频率、途径、天数、单位不能为空"
        },
        "inspectionView": {
            "requiredMsg": "检查检验的单位、总量不能为空"
        },
        "disposalView": {
            "requiredMsg": "治疗的单位、总量不能为空"
        },
        "operationView": {
            "requiredMsg": "手术的单位、总量不能为空"
        }
    },
    "appointmentSign": {
        "title": "预约签到",
        "tel": "手机号：",
        "signBtn": "签到",
        "column": {
            "time": "时间",
            "doctor": "医师"
        }
    },
    "caseInfoCard": {
        "retail": "零售",
        "unpaid": "未收费",
        "returnText": "退",
        "chineseExtra": "处方",
        "injectionView": "-附加项目",
        "injectionView_2": "群组",
        "soapTemperature": "体温{n}度，",
        "soapPulse": "脉搏{n}次，",
        "soapBreathe": "呼吸{n}次/分钟，",
        "soapHeartRate": "心率{n}次/分钟，",
        "soapDiastolicSystolicPressure": "血压{d}/{s}mmHg；"
    },
    "checkboxTabs": {
        "checkedAll": "全选(模板)"
    },
    "customArco": {
        "inputTriggerTag": {
            "tip": "若是医保结算，需使用标准诊断名称",
            "placeH": "新增{name}",
            "common": "常用",
            "diagnosis": "诊断",
            "discriminate": "辨证",
            "treatment": "治法",
            "delModal": {
                "title": "确认删除",
                "content": "是否确认删除{name}？"
            },
            "isInclude": "{name}已存在！"
        }
    },
    "fileIcon": {
        "delTitle": "确认删除",
        "delContent": "是否确认删除？"
    },
    "caseInfoView": {
        "stopUnCopy": "已停用，无法复制！",
        "delUnCopy": "已删除，无法复制！"
    },
    "printModal": {
        "printer": "选择打印机",
        "direction_1": "竖向",
        "direction_2": "横向",
        "count": "份数",
        "offset": {
            "top": "上偏移",
            "left": "左偏移"
        },
        "margin": {
            "top": "上边距",
            "bottom": "下边距",
            "left": "左边距",
            "right": "右边距"
        },
        "content": "打印内容"
    },
    "stackModal": {
        "select": "分类",
        "select_1": "科室",
        "select_2": "个人",
        "packageName": "模板名称搜索",
        "tipTitle": "提示",
        "tipContent": "请修改模板后再使用！",
        "unitChange": "【{name}】的单位发生调整；"
    },
    "patientBasicModal": {
        "add": "【新增】",
        "edit": "【修改】",
        "infoTitle_1": "基本信息",
        "infoTitle_1_1": "标签：",
        "patiname": "姓名",
        "birthdatetime": "出生日期",
        "sex": "性别",
        "age": "年龄",
        "idTypeName": "证件类型",
        "idCardNo": "证件号码",
        "comingWayName": "到院途径",
        "tel": "手机号码",
        "isWillingTel": "患者不愿留手机号",
        "healthInsuranceCard": "医保卡号",
        "infoTitle_2": "详细信息",
        "patientFrom": "病患来源",
        "patientFromMark": "病患来源备注",
        "jobName": "职业",
        "folkName": "民族",
        "marriageName": "婚姻",
        "contactPeople": "联系人",
        "relationShip": "关系",
        "contactTel": "联系电话",
        "address": "现住址",
        "patientMemo": "备注",
        "infoTitle_3": "过敏史与重大病史",
        "allergyItem": "过敏史",
        "diseaseItem": "重大病史"
    },
    "patientTag": {
        "tagTitle_1": "文字标签",
        "tagTitle_2": "表情标签",
        "settingTagTitle": "文字标签设置"
    },
    "patientTitle": {
        "tel": "手机号："
    },
    "payDiscount": {
        "title": "支付优惠",
        "memberLabel": "会员",
        "memberTel": "会员手机号",
        "alertTitle": "折扣",
        "notEdit_1": "医生议价后，不参与会员优惠",
        "notEdit_2": "一个收费项目若参与多个优惠活动，默认取最优惠的折扣",
        "total": "优惠金额总计",
        "totalUnit": "元"
    },
    "payModal": {
        "anonymity": "匿名",
        "tel": "手机号：",
        "ybTitle": {
            "fund": "统筹基金",
            "siPersonal": "个人账户",
            "cash": "现金",
            "noNeed": "医保外"
        },
        "ybSuffix": "{l}支付(元)",
        "memberQuit": {
            "recharge": "本金余额",
            "send": "赠金余额"
        },
        "bargain": "议价",
        "resetBtn": "恢复",
        "surplus": "待收金额",
        "chosPayEmpty": "请选择支付方式",
        "overflowMember": "当前输入金额超过会员余额，请修改",
        "surplusMoney": "可用余额",
        "quitEmpty": "请选择退回方式",
        "quitReason": "{t}原因",
        "quitLabel": "{l}退回",
        "quitSendAmt": "赠金扣除",
        "refundReason": "退款原因",
        "seller": "销售员",
        "invoice": {
            "num": "发票号码",
            "sn": "当前发票号码"
        },
        "dispense": "同时发药",
        "printXp": "打印小票",
        "okTip_1": "当前实收金额超过应收金额，请修改",
        "okTip_2": "当前实收金额不足，请修改",
        "payMode": {
            "wx": "微信",
            "zfb": "支付宝",
            "jh": "聚合",
            "xj": "现金",
            "hy": "会员",
            "yb": "医保卡",
            "szRMB": "数字人民币"
        },
        "maxPayLimit": "最多支持3种不同的支付方式！",
        "successMsg": {
            "regis": "挂号成功！",
            "sign": "签到成功！",
            "collectfee": "收费成功！",
            "memberFee": "充值成功！",
            "quit": "退号成功！"
        },
        "okMsg": {
            "member": "会员余额不足！",
            "principal": "请输入退回金额！",
            "biggerPrincipal": "退回金额不能大于本金余额！",
            "biggerSend": "赠金扣除不能大于赠金余额！"
        }
    },
    "needClient": {
        "title": "下载客户端",
        "download": "下载"
    },
    "verifyCationCode": {
        "title": "请完成图形验证",
        "input": "输入图形验证码",
        "refresh": "看不清？点击刷新"
    },
    "settingModal": {
        "defaultName": "煎法",
        "add": "新增{n}"
    },
    "registerSceneModal": {
        "patiname": "患者姓名",
        "mainIdentity": "看诊身份",
        "doctorLevel": "看诊级别",
        "payAmt": "看诊金额",
        "disAmt": "支付优惠",
        "changeDis": "修改优惠",
        "pretherapy": "预诊",
        "sign": "签到",
        "regis": "挂号",
        "booking": "预约签到"
    },
    "autoUpdate": {
        "title": "更新提示",
        "content": "版本已更新，请点击按钮进行更新"
    },
    "exportExcel": {
        "empty": "暂无可导出的数据！"
    },
    "common": {
        "copyright": "Copyright © 南京霆旺科技有限公司版权所有",
        "pwdTip": "应网络安全有关部门要求，密码须是6～20位英文字母、数字、字符!{'@'}#$%^&*()_+=.-组合",
        "cancel": "取消",
        "save": "保存",
        "ok": "确定",
        "close": "关闭",
        "edit": "编辑",
        "unlimited": "不限",
        "openUse": "启用",
        "stopUse": "停用",
        "add": "新增",
        "amend": "修改",
        "delete": "删除",
        "success": "成功！",
        "editSuccess": "编辑成功！",
        "openUseSuccess": "启用成功！",
        "stopUseSuccess": "停用成功！",
        "addSuccess": "新增成功！",
        "deleteSuccess": "删除成功！",
        "amendSuccess": "修改成功！",
        "operationSuccess": "操作成功！",
        "fail": "失败！",
        "operation": "操作",
        "yes": "是",
        "no": "否",
        "mainIdentityLabel": "看诊身份",
        "mobile": "手机号码",
        "telephone": "手机号码",
        "idNum": "身份证号",
        "birthday": "出生日期",
        "name": "姓名",
        "gender": "性别",
        "male": "男",
        "female": "女",
        "section": "科室",
        "memo": "备注",
        "pyCode": "拼音码",
        "refresh": "刷新",
        "tipTitle": "提示",
        "tipTitle_2": "提醒",
        "clearScreen": "清屏",
        "readIdCard": "读身份证",
        "readMedicalCard": "读医保卡",
        "basicTitle": "患者基本资料",
        "wareHouse": "药房",
        "startDate": "开始日期",
        "endDate": "结束日期",
        "pricePrefix": "¥",
        "back": "返回",
        "ratioUnit": "付",
        "export": "导出",
        "print": "打印",
        "all": "全部",
        "alertTips": "实收合计 = 应收合计 - 优惠金额 - 议价 - 短溢款 - 退款金额",
        "checkDetail": "查看详情",
        "day": "今天",
        "week": "本周",
        "month": "本月",
        "year": "今年",
        "check": "查看",
        "changePatiName_1": "患者原姓名",
        "changePatiName_2": "现改为",
        "changePatiName_3": "，确定修改？",
        "saveSuccessed": "保存成功！",
        "saveFailed": "保存失败！",
        "tollCollector": "收费员",
        "refundOfficer": "退费员",
        "feesProcessedName": "代加工",
        "settingBtn": "设置",
        "birth_year": "岁",
        "birth_year_simple": "岁",
        "birth_month": "月",
        "birth_month_simple": "月",
        "birth_day": "日",
        "birth_day_simple": "日",
        "ageTips": "可直接输入年龄",
        "repeatRegis": "已经有该班别该医师的挂号资料，是否继续？",
        "rangeDateSplit": " 至 ",
        "uploadFileBtn": "上传{label}",
        "uploadBlack": "后缀名为.exe的文件不可上传！",
        "amountPrefix": "",
        "diastolicPressure": "舒张压",
        "systolicPressure": "收缩压",
        "tagName": "标签"
    },
    "commonTableSet": {
        "chScientificName": "项目名称",
        "drugSpec": "规格",
        "manufacture": "生产厂商",
        "price": "单价",
        "priceY": "单价(元)",
        "amount": "金额(元)",
        "totalAmount": "费用(元)",
        "dosageName": "剂量",
        "freqName": "频率",
        "usageName": "途径",
        "usageName_2": "用法",
        "tqty": "总量",
        "quantity": "数量",
        "number": "数量",
        "unit": "单位",
        "days": "天数",
        "region": "部位",
        "operationNumber": "刀口",
        "memo": "备注",
        "action": "操作",
        "viewDetails": "查看明细",
        "receivableAmount": "应收金额(元)",
        "receiptsAmt": "实收金额(元)",
        "costAmount": "成本金额(元)",
        "profitAmount": "毛利金额(元)",
        "profitRate": "毛利率"
    },
    "commonPrint": {
        "size_A4": "A4",
        "size_A5": "A5",
        "size_XP": "小票",
        "size_PT": "瓶贴",
        "size_FP": "发票",
        "settingTitle": "打印设置",
        "setting": "打印设置",
        "printingName": "打印机",
        "pageSize": "纸张尺寸",
        "printNumers": "份数",
        "invoiceType": "发票类型",
        "invoiceSetting": "发票代码",
        "invoiceNumber": "发票号码",
        "unInstallPrint": "您还未安装打印组件",
        "install": "安装"
    },
    "prescription": {
        "medicalRecords": "病历",
        "westernMedicine": "西/成药",
        "chineseHerbal": "中药",
        "injectionView": "输注",
        "inspectionView": "检验检查",
        "disposalView": "治疗",
        "operationView": "手术"
    },
    "month": {
        "Jan": "一月",
        "Feb": "二月",
        "Mar": "三月",
        "Apr": "四月",
        "May": "五月",
        "Jun": "六月",
        "Jul": "七月",
        "Aug": "八月",
        "Sep": "九月",
        "Oct": "十月",
        "Nov": "十一月",
        "Dec": "十二月"
    },
    "otherMsg": {
        "loginSuccess": "登陆成功！",
        "noMenu": "当前账号无菜单，请联系{name}负责人！",
        "serviceLoading": "系统加载中，请稍后。",
        "serviceError": "服务器连接失败！",
        "loginExpired": "登录已过期，请重新登录！",
        "tabTitleExtra": "旺诊云",
        "fileMaxSize": "文件大小不能超过10M！"
    },
    "partModel": {
        "checkAll": "全选",
        "edit_1": "共{num}付，退",
        "edit_2": "可退{num}付，退",
        "unit": "付",
        "quantityUnit": "*{num}付",
        "chooseAmt": "选中项目合计：",
        "actualReturn": "实退：",
        "returnDrug": "确认退药",
        "returnDrugTip": "是否确认退药操作？",
        "returnUnit": " doses return"
    },
    "returnInfo": {
        "returnedTitle": "已退",
        "partTableSet": {
            "status": "状态",
            "backAccount": "退费数量",
            "totalAmount": "金额(元)",
            "receiptsAmt": "实收(元)"
        }
    },
    "performance": {
        "performancemanage": {
            "title": "Commission Scheme",
            "searchPlaceholder": "Commission Scheme Name Search",
            "addBtnTxt": "Add Commission Scheme",
            "commissionSchemesName": "Commission Scheme Name",
            "userInfo": "Commission Scheme Uers",
            "commissionSchemesType": "Commission Scheme Type",
            "computerule": "Commission Calculation Rule：",
            "creationTime": "Creation Time",
            "delTitle": "Confirm Deletion",
            "delContent": "Confirm to delete?",
            "delSuccess": "Deleted Successfully!"
        },
        "performancemanageForm": {
            "addBtnTxt": "Add Commission Scheme",
            "editBtnTxt": "Edit Commission Scheme",
            "commissionSchemesName": "Commission Scheme Name",
            "userInfo": "Commission Scheme Uers",
            "itemInfo": "Commission Scheme Items",
            "commissionSchemesType": "Commission Scheme Type",
            "item": {
                "orderTypeName": "Item Type",
                "price": "Selling Price",
                "coefficient": "Commission Coefficient",
                "commission": "Commission",
                "proportion": "Proportion",
                "fixed": "Fixed"
            }
        },
        "performancereport": {
            "title": "Commission Report",
            "searchPlaceholder": "Commission Report Name Search",
            "searchInfo": {
                "preformanceList": "Commission Scheme List"
            },
            "searchtable": {
                "userName": "User Name",
                "performanceManagementName": "Scheme",
                "total": "Total",
                "fixed": "Fixed",
                "chinesePatentDrug": "Chinese Patent Drug",
                "westernDrug": "Western Drug",
                "chineseHerbalDrug": "Chinese Herbal Drug",
                "consumable": "Consumable",
                "laboratory": "Laboratory",
                "examination": "Examination",
                "treatment": "Treatment",
                "surgery": "Surgery",
                "consultationFee": "Consultation Fee",
                "infusionAddition": "Infusion Additional",
                "inpatientItem": "Inpatient Item"
            },
            "exportFileName": "Commission Report"
        },
        "tabsList": {
            "performancemanage": "Commission Scheme",
            "performancereport": "Commission Report"
        },
        "common": {
            "edit": "Edit",
            "delete": "Delete"
        }
    },
    "inpatientPharmacy": {
        "medicineDispense": {
            "tab_1": "Long-term Medical Orders",
            "tab_2": "Temporary Medical Orders",
            "placeHolderList": {
                "pharmacy": "Pharmacy",
                "ward": "Nursing Station",
                "drugDate": "Drug Date",
                "bedNo": "Bed No.",
                "startDate": "Administration Date",
                "endDate": "End Date",
                "queryText": "File No. Search"
            },
            "printBtn": {
                "name": "List Printing",
                "list_1": "Print The List",
                "list_2": "Print Settings",
                "reprint": "Reprint List",
                "print": "Print",
                "startPrinting": "Start Printing",
                "endPrinting": "End Printing"
            },
            "checkAll": "Select all",
            "tableSet": {
                "medicalOrdersName": "Medical Orders Name",
                "specification": "Specification",
                "dosage": "Dosage",
                "frequency": "Frequency",
                "usage": "Usage",
                "tqty": "Total",
                "closingTime": "Closing Time",
                "startTime": "Start Time",
                "expirationTime": "Expiration Time",
                "changeStatus": "Change Status",
                "invalidatePrescriptionNo": "Invalidate Prescription No."
            },
            "prescriptionNo": "Prescription No.: {num}",
            "inpatientDepartment": "Inpatient Department: {name}",
            "attendingDoctor": "Attending Doctor: {name}",
            "admissionTime": "Admission Time: {time}",
            "diagnosis": "Diagnosis: {name}",
            "allergicHistory": "Allergic History: {name}",
            "majorMedicalHistory": "Major Medical History: {name}",
            "reprintList": "Reprint List",
            "printTip": "Please select at least one of the list to print!"
        },
        "refundableDrugsList": {
            "startDate": "Start Date",
            "endDate": "End Date",
            "printBtn": "Printing",
            "tableSet": {
                "fileNo": "File No.",
                "name": "Name",
                "bedNo": "Bed No.",
                "medicalOrdersNo": "Medical Orders No.",
                "drugWithdrawalAmount": "Drug Withdrawal Amount",
                "unit": "Unit",
                "drugWithdrawalDoctor": "Drug Withdrawal Doctor",
                "medicalOrdersType": "Medical Orders Type"
            }
        },
        "returnMedicine": {
            "tab_1": "Check and Receive Withdrawal Drug",
            "tab_2": "Withdrawn Drug",
            "confirm": "Confirm",
            "export": "Export",
            "tableSet": {
                "fileNo": "File No.",
                "name": "Name",
                "bedNo": "Bed No.",
                "MedicalOrderName": "Medical Order Name",
                "withdrawalAmount": "Withdrawal Amount",
                "actualWithdrawalAmount": "Actual Withdrawal Amount",
                "unit": "Unit",
                "doctor": "Doctor",
                "MedicalOrderType": "Medical Order Type",
                "exportName": "{name}-{date}"
            }
        },
        "sendConfirm": {
            "medicalOrdersType": "Medical Orders Type",
            "dispensingStatus": "Dispensing Status",
            "confirmBtn": "Confirm Dispensing",
            "cancelBtn": "Cancel Dispensing",
            "tableSet": {
                "prescriptionNo": "Prescription No.",
                "specification": "Specification",
                "dispensingStatus": "Dispensing Status"
            }
        }
    },
    "nursingSystem": {
        "manage": {
            "status": "Status",
            "queryText": "Patient Name / File No. / Doctor Name Search",
            "btnGroup": {
                "btn_zk": "Transfer Department",
                "btn_zys": "Change Doctor",
                "btn_zc": "Bed Transfer",
                "btn_fy": "Transfer Fee Category"
            },
            "popPleaceHolder": {
                "newKS": "New Department",
                "newZZENYS": "New Attending Doctor",
                "newZZHIYS": "New Primary Care Doctor",
                "newZYYS": "New Resident Doctor",
                "newBQ": "New Ward",
                "newBC": "New Bed",
                "newFYLB": "New Fee Category",
                "reason": "Transfer Reason"
            }
        },
        "giveConfirm": {
            "drugAdministrationDate": "Drug Administration Date",
            "btnGroup": {
                "btn_1": "Confirmation of Drug Administration(V)",
                "btn_2": "The patient is not present(O)",
                "btn_3": "Suspension of Drug Administration(☆)",
                "btn_4": "Discontinue Drug for the day(X)"
            },
            "longTermDrug": "Long-term Drug",
            "TemporaryDrug": "Temporary Drug",
            "tableSet": {
                "startTime": "Medical Orders Starting Time",
                "drugName": "Drug Name",
                "group": "Group",
                "dose": "Dose",
                "drugAdministrationTime": "Drug Administration Time",
                "drugAdministrationStatus": "Drug Administration Status"
            }
        }
    }
}